/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-undef */
import { IDatabaseModel } from 'src/shared/interface/dexie.interface';
import { localStorageLogger } from 'src/shared/lib/logger/local-logger-manager';

// Example of database versionning : https://dexie.org/docs/Tutorial/Design#database-versioning

const modelDbUser: Array<IDatabaseModel> = [
  {
    version: 1,
    schema: {
      user: 'id, active, isActiveLocally, username, email, roles, profile, chkRemember', // NOT indexed fields : refresh_token
    },
  },
  {
    version: 2,
    schema: {
      config: '++id, lastUserCrypto',
    },
  },
  {
    version: 3,
    schema: {
      user: 'id, data, uuid',
      config: null,
    },
  },
];

const modelDbData: Array<IDatabaseModel> = [
  {
    version: 1,
    schema: {
      program:
        '&id, beltCode, comment, gradeLevel, gradeOrder, isDan, isKyu, label, programOrder, videos',
      config: '++id, uploader, security, version',
    },
  },
  {
    version: 2,
    schema: {
      release: 'id, version, deployedAt',
    },
    upgradeFn: (tx) => {
      loggMigration(
        1,
        2,
        'ESP Kobudo v1.1.0 (dbData) : adding table "release"',
      );
    },
  },
  {
    version: 3,
    schema: {
      cachedVideo: 'id',
    },
    upgradeFn: (tx) => {
      loggMigration(
        2,
        3,
        'ESP Kobudo v1.4.0 (dbData) : adding table "cachedVideo"',
      );
    },
  },
  {
    version: 4,
    schema: {
      user: 'id, data, uuid',
    },
    upgradeFn: (tx) => {
      loggMigration(3, 4, 'ESP Kobudo v1.6.0 (dbData) : adding table "user"');
    },
  },
  {
    version: 5,
    schema: {
      release: null,
      changelog: '++id, version, releases',
    },
    upgradeFn: (tx) => {
      loggMigration(4, 5, 'ESP Kobudo v2.2.1 (dbData) : renaming and restructuring table "release" into "changelog"');
    },
  },
];

const modelDbServiceWorker: Array<IDatabaseModel> = [
  {
    version: 1,
    schema: {
      state: '++id, version, status, timestamp',
    },
  },
];

const loggMigration = (
  oldVersion: number,
  newVersion: number,
  purpose: string,
) => {
  localStorageLogger?.info(
    `[Database migration] from v${oldVersion} to v${newVersion} : ${purpose}`,
  );
};

export { modelDbUser, modelDbData, modelDbServiceWorker };
